/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareLookupItem
 */
export interface MatrixCareLookupItem {
    /**
     * MatrixCare ElementId / Id GUID — passed through to createPatient.
     * @type {string}
     * @memberof MatrixCareLookupItem
     */
    id: string;
    /**
     * Human-readable text (ElementText, trimmed).
     * @type {string}
     * @memberof MatrixCareLookupItem
     */
    label: string;
}

/**
 * Check if a given object implements the MatrixCareLookupItem interface.
 */
export function instanceOfMatrixCareLookupItem(value: object): value is MatrixCareLookupItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function MatrixCareLookupItemFromJSON(json: any): MatrixCareLookupItem {
    return MatrixCareLookupItemFromJSONTyped(json, false);
}

export function MatrixCareLookupItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareLookupItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function MatrixCareLookupItemToJSON(json: any): MatrixCareLookupItem {
    return MatrixCareLookupItemToJSONTyped(json, false);
}

export function MatrixCareLookupItemToJSONTyped(value?: MatrixCareLookupItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

